import { useZero } from "@rocicorp/zero/react";
import { nanoid } from "nanoid";
import { getInitialConnectorValues } from "../../shared/connectors/getInitialConnectorValues";
import { workflowApp } from "../../shared/connectors/workflowApp/manifest";
import { sharedMutators } from "../../shared/mutators";
import { useRenderWithPlaceholders } from "../components/ConnectorModal/renderWithPlaceholders";
import { useDefaultConnectorGrants } from "./useDefaultConnectorGrants";

// Creates a workflow-backed connector for the workflow and returns its id,
// or null when grants aren't loaded yet. Shared by the header button and the
// in-chat "set up as connector" prompt.
export function useExposeWorkflowAsConnector({
  workflowId,
  spaceId,
  workflowName,
}: {
  workflowId: string;
  spaceId: string;
  workflowName: string;
}): () => string | null {
  const z = useZero();
  const defaultConnectorGrants = useDefaultConnectorGrants(spaceId);
  const renderWithPlaceholders = useRenderWithPlaceholders();
  return () => {
    if (!defaultConnectorGrants) return null;
    const initial = getInitialConnectorValues(
      workflowApp,
      renderWithPlaceholders
    );
    const newAppId = nanoid(12);
    z.mutate(
      sharedMutators.createConnectedApp({
        connectedAppId: newAppId,
        name: workflowName,
        identifier: workflowApp.identifier,
        urlPattern: initial.urlPattern,
        configuration: initial.configuration,
        secrets: {},
        grants: defaultConnectorGrants,
      })
    );
    z.mutate(
      sharedMutators.setWorkflowAppBacking({
        connectedAppId: newAppId,
        workflowId,
      })
    );
    return newAppId;
  };
}
